import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "react-intl-tel-input/dist/main.css";
import RequiredLabel from "../Common/RequiredLabel/RequiredLabel";
import { Label } from "../Common/Label/Label";
import HelperService from "../../Services/HelperService";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";

interface ChangeEmailModalProps {
    show: boolean;
    onHide: () => void;
    onSave: (email: string) => void;
}

const ChangeEmailModal: React.FC<ChangeEmailModalProps> = ({
    show,
    onHide,
    onSave,
}) => {
    const [email, setEmail] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const handleSave = () => {
        if (!email || (email && !HelperService.isValidEmail(email))) {
            setErrorFlag(true);
            return
        }
        handleChangeEmail()
        // onSave(email);
        // onHide();
    };

    const handleChangeEmail = () => {
        WebService.addLoader("save_change_email")
        return WebService.postAPI({
            action: `change-email/request`,
            body: {
                email: email,
                has_resent: 0
            },
            isShowError: false,
        })
            .then((res: any) => {
                if (res?.status) {
                    toast.success(res?.message);
                    onSave(email)

                } else {
                    toast.error(res.message);
                }
            })
            .catch((error: any) => {
                toast.error(error?.response?.data?.message);
                WebService.removeLoader("save_basic_details");
                return error;
            }).finally(() => {
                WebService.removeLoader("save_change_email")
            })

    }

    return (
        <Modal show={show} onHide={onHide} centered >
            <Modal.Header closeButton>
                <Modal.Title>Change Email</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <RequiredLabel isRequired={true}>
                    Enter New Email Address
                </RequiredLabel>
                <div className="mt-2 mb-2">
                    <Form.Control
                        type="text"
                        placeholder="Please enter your new email address"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {errorFlag && (!email || (email && !HelperService.isValidEmail(email))) && <Label title="Please enter valid email" modeError={true} />}
                </div>

                <div className="d-flex justify-content-center gap-3 mt-3">
                    <Button variant="secondary" onClick={onHide}>
                        Cancel
                    </Button>
                    <Button id="save_change_email" variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </div>

            </Modal.Body>


        </Modal >
    );
};

export default ChangeEmailModal;
